import { BaseService } from "./baseService";
import httpRequest from "./index";
import type { CustomerInvoiceHeader, Page } from "@zhihaoscm/entity";

/** 发票表单不再反向依赖 Vue 单文件组件。 */
export type CustomerInvoiceHeaderForm = Partial<CustomerInvoiceHeader>;

export class InvoiceService extends BaseService<any, any, any, any> {
    // 查询发票抬头列表
    public async getInvoiceList(params: any): Promise<Page<CustomerInvoiceHeader>> {
        const { data } = await this.service.get(`${this.path}/customPaging`, { params });
        return data;
    }

    // 查询发票抬头详情
    public async getInvoiceInfoById(id: number): Promise<CustomerInvoiceHeader> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }

    // 新增发票抬头
    public async addInvoice(customerInvoiceHeaderForm: CustomerInvoiceHeaderForm): Promise<any> {
        const { data } = await this.service.post(`${this.path}`, customerInvoiceHeaderForm);
        return data;
    }

    // 修改发票抬头
    public async editInvoice(id: number, customerInvoiceHeaderForm: CustomerInvoiceHeaderForm): Promise<any> {
        const { data } = await this.service.put(`${this.path}/${id}`, customerInvoiceHeaderForm);
        return data;
    }

    // 设置默认抬头
    public async setDefault(id: number, customerInvoiceHeaderForm: CustomerInvoiceHeaderForm): Promise<any> {
        const { data } = await this.service.put(`${this.path}/${id}`, customerInvoiceHeaderForm);
        return data;
    }

    // 删除发票抬头
    public async deleteInvoice(id: number): Promise<any> {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }
}

export const invoiceService = new InvoiceService("/customer/invoice/header", httpRequest);
